import ctaBackground from '@cannect/assets/img/home/next-step-cta-bg.webp'
import { Typography } from '@cannect/new-components/atoms'
import { JourneyCard } from '@cannect/new-components/molecules'
import { JOURNEY_CARDS } from '@cannect/new-components/molecules/JourneyCard/constants'

/**
 * Seção de CTA que fecha a página, acima do footer (Figma node 4333:1843).
 *
 * A foto é o próprio fundo da seção. No design ela entra escalada a 103,85% da largura e deslocada
 * em -38,38% no topo — transformação que só fecha na proporção do desktop e quebraria no mobile.
 * Por isso o asset já foi recortado na janela visível do design (proporção 3,356, igual à da
 * seção): `object-cover` então rende 1:1 em 1440 e continua se comportando em outras proporções.
 *
 * A revisão trocou as três pills ("Encontrar meu caminho" / "Buscar produtos" / "Já sou paciente")
 * pelos mesmos três `JourneyCard` do hero. Isso encerra a duplicação de CTAs no rodapé que a
 * análise apontava — as duas fileiras agora oferecem as mesmas três entradas.
 */
export const NextStepCTA = () => (
  <section aria-labelledby="next-step-cta-heading" className="relative w-full overflow-hidden bg-marketplace-1000">
    <img
      src={ctaBackground}
      alt=""
      aria-hidden
      loading="lazy"
      decoding="async"
      className="absolute inset-0 h-full w-full object-cover object-center"
    />

    <div className="relative mx-auto flex w-full max-w-[1230px] flex-col gap-16 px-8 pb-16 pt-16">
      <div className="flex max-w-[534px] flex-col gap-2">
        <p className="m-0 text-base leading-[1.6] text-neutral-50">Comece hoje</p>

        <div className="flex flex-col gap-6">
          <Typography.Heading
            id="next-step-cta-heading"
            level={2}
            type="headingTwo"
            weight="regular"
            className="m-0 max-w-[480px] leading-[49.28px] tracking-[-0.448px] text-neutral-50">
            {/* `span`, não `em`: o itálico aqui é assinatura de marca, não ênfase semântica. */}
            Qual é o próximo passo para o seu <span className="italic">cuidado?</span>
          </Typography.Heading>

          <p className="m-0 text-base font-light leading-[1.4] text-neutral-50">
            Se você não tem certeza, a gente ajuda a encontrar o caminho, sem que isso comece obrigatoriamente por uma
            consulta.
          </p>
        </div>
      </div>

      <ul className="m-0 flex list-none flex-col gap-4 p-0 lg:flex-row">
        {JOURNEY_CARDS.map((card) => (
          <li key={card.title} className="flex min-w-0 lg:flex-1">
            <JourneyCard {...card} />
          </li>
        ))}
      </ul>
    </div>
  </section>
)
